import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useCallback } from 'react';
import { toast } from 'material-react-toastify';
import { useAddresses } from '../../../../hooks/useAddresses';
import { bodyWidth } from '../../../../utils/Style';
import { AccountNavbar } from '../../AccountNavbar';
import { NewAddressCard } from '../../../../components/Address/NewAddressCard';
import { AddressCardPlaceholder } from '../../../../components/Address/AddressCardPlaceholder';
import { AddressCard } from '../../../../components/Address/AddressCard';
import { Address } from '../../../../interfaces/Address/Address';
import { deleteAddress } from '../../../../api/Address';
import { GenericHelmet } from '../../../../components/Helmet/GenericHelmet';
import { useLocalizedText } from '../../../../hooks/useLocalizedText';

export const AddressesPage = () => {
  const t = useLocalizedText();

  const { addresses, refreshAddresses, loading } = useAddresses();

  const handleDelete = useCallback((address: Address) => {
    deleteAddress(address.id)
      .then(() => {
        toast.success(t('address.page.delete_successful'));
        refreshAddresses();
      })
      .catch((err) => toast.error(err.message));
  }, []);

  const itemSize = {
    xs: 12,
    md: 6,
    xl: 4,
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <GenericHelmet title={t('address.page.my_addresses')} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: bodyWidth,
          pb: 3,
          px: 1.5,
          gap: 1.5,
          boxSizing: 'border-box',
        }}
      >
        <AccountNavbar selectedTab='address' />

        <Typography sx={{ fontSize: '1.75rem', fontWeight: 600 }}>
          {t('address.page.addresses')}
        </Typography>

        <Grid container spacing={2} width='100%'>
          <Grid size={itemSize}>
            <NewAddressCard />
          </Grid>

          {loading && !addresses.length
            ? Array(3)
                .fill(null)
                .map((_, i) => (
                  <Grid key={i} size={itemSize}>
                    <AddressCardPlaceholder />
                  </Grid>
                ))
            : addresses.map((address, i) => (
                <Grid key={i} size={itemSize}>
                  <AddressCard
                    address={address}
                    isDefault={!i}
                    onDelete={() => handleDelete(address)}
                  />
                </Grid>
              ))}
        </Grid>
      </Box>
    </Box>
  );
};
